<template>
    <div class="p-2">

        <div class="form-group d-flex border-bottom">
            <div class="col-18">{{ $t('translations.name')}}:</div><div class="col-6"> {{this.$parent.item.name}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class="col-18">{{ autobrand('translations.group_can_have_requests_assigned')}}:</div><div class="col-6"> {{this.$parent.item.group_assignable ? $t('translations.yes') : $t('translations.no')}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class="col-18">{{ autobrand('translations.members_can_have_requests_assigned')}}:</div><div class="col-6"> {{this.$parent.item.members_assignable ? $t('translations.yes') : $t('translations.no')}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class="col-18">{{ autobrand('translations.patients_can_choose_group_members')}}:</div><div class="col-6"> {{this.$parent.item.patient_requestable ? $t('translations.yes') : $t('translations.no')}}</div>
        </div>

        <div class="form-group d-flex border-bottom">
            <div class="col-18">{{ $t('translations.can_complete_on_behalf_of_another')}}:</div><div class="col-6"> {{this.$parent.item.completes_on_behalf_of ? $t('translations.yes') : $t('translations.no')}}</div>
        </div>

        <!-- <div class="form-group d-flex border-bottom">
            <div class="col-18">{{ $t('translations.capacity')}}:</div><div class="col-6"> {{this.$parent.item.capacity}}</div>
        </div> -->

        <div class="form-group">
            {{ $t('translations.members')}}:
            <ul>
                <template v-for='usersusergroup in this.$parent.item.usersusergroup'>
                    <li :key='usersusergroup.user.id' v-if='usersusergroup.user'>
                        {{usersusergroup.user.surname + ", " + usersusergroup.user.forenames}}
                    </li>
                </template>
            </ul>
        </div>


    </div>
</template>

<script>
	export default {
    }
</script>
